const APPS = [
  { prefix: "apps/web/", app: "web", color: "blue" },
  { prefix: "packages/", app: "shared", color: "gray" },
];
const MOBILE = { app: "mobile", color: "grape" };

/**
 * Display parts for one place a translation key is used. The app comes from
 * the file path (anything not web or shared is one of the mobile apps); the
 * label is the AI-written screen, minus the app name it starts with
 * ("Mobile: Menu tab - account row"), which the badge already shows. Falls
 * back to the file path when the notes have no screen for it.
 */
export function describeLocation({ file, screen }) {
  const { app, color } =
    APPS.find(({ prefix }) => file.startsWith(prefix)) ?? MOBILE;
  const label = screen ? screen.replace(/^(web|mobile|shared):\s*/i, "") : file;

  return { app, color, label };
}
